module.exports = __webpack_public_path__ + "static/media/glxt.307c84f6.svg";